import { trackInAmplitude } from 'utils/tracking/amplitude'
import { AmplitudeEvent } from 'utils/tracking/amplitude/amplitude.interface'

export const trackWithOrigin = (event: AmplitudeEvent, payload = {}) => {
  trackInAmplitude(event, { origin: 'taurine', ...payload })
}
